angular.module('zc.projects')

.directive 'zcDeletedItemDetector', (ProjectDeletedItemDetector, Meta, BaseProjectCrudEditor) ->

  class DeletedItemDetector extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality

  editor = new DeletedItemDetector(
    ProjectDeletedItemDetector
    Meta
    '/templates/projects.settings/other/deleted_item_detector.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/deleted_item_detector.directive.coffee